import React from 'react';
import { Box, Stack, Typography, Button } from '@mui/material';
import VideocamRoundedIcon from '@mui/icons-material/VideocamRounded';
import OpenInNewRoundedIcon from '@mui/icons-material/OpenInNewRounded';
import { zoomAppLink, zoomWebLink } from './iosFallback';

const BRAND_GRAD = 'linear-gradient(135deg, rgba(56,189,248,0.9), rgba(37,99,235,0.9))';

/**
 * Shown to iPhone/iPad users instead of the (mic-less) browser meeting.
 * Opens the real Zoom app via deep link; offers the web fallback too.
 */
export default function IosJoinGate({ roomName, meetingNumber, password, onBrowserAnyway }) {
  return (
    <Box sx={{ position: 'fixed', inset: 0, bgcolor: '#0b1020', color: '#e2e8f0', display: 'grid', placeItems: 'center', p: 3, zIndex: 1300 }}>
      <Stack spacing={3} alignItems="center" sx={{ maxWidth: 420, textAlign: 'center' }}>
        <Box sx={{ width: 64, height: 64, borderRadius: 3, background: BRAND_GRAD, display: 'grid', placeItems: 'center', color: '#fff' }}>
          <VideocamRoundedIcon sx={{ fontSize: 34 }} />
        </Box>
        <Typography variant="h5" sx={{ color: '#fff' }}>{roomName || 'Join meeting'}</Typography>
        <Typography sx={{ color: '#94a3b8' }}>
          iPhone &amp; iPad can’t use the microphone inside the browser (an Apple limitation).
          Tap below to join in the <b>Zoom app</b> — you’ll have full audio.
        </Typography>

        <Button
          fullWidth size="large" variant="contained"
          href={zoomAppLink(meetingNumber, password)}
          startIcon={<OpenInNewRoundedIcon />}
          sx={{ py: 1.5, background: BRAND_GRAD, '&:hover': { background: BRAND_GRAD } }}
        >
          Open in Zoom app
        </Button>

        <Button fullWidth href={zoomWebLink(meetingNumber, password)} sx={{ color: '#cbd5e1' }}>
          Don’t have the app? Join on zoom.us
        </Button>

        {onBrowserAnyway && (
          <Button size="small" onClick={onBrowserAnyway} sx={{ color: '#64748b' }}>
            Continue in this browser anyway (no mic)
          </Button>
        )}
      </Stack>
    </Box>
  );
}
